import { Box, Table, Typography } from "@mui/material";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { GridColDef, GridValidRowModel } from "@mui/x-data-grid";
import React from "react";

type TopFiveProps = {
  title: string;
  columns: GridColDef[];
  rows: GridValidRowModel[];
  getRowId: (row: GridValidRowModel) => string;
  filterModal?: React.ReactElement;
};

export const TopFive = (props: TopFiveProps) => {
  return (
    <Box
      sx={{
        borderRadius: "30px",
        background: (theme) => theme.palette.common.white,
        paddingX: "1.5rem",
        paddingY: "2rem",
        flex: 1,
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        sx={{
          marginBottom: "1.5rem",
        }}
      >
        <Typography
          textAlign="left"
          sx={{
            fontWeight: "700",
            fontSize: "24px",
            lineHeight: "26px",
            color: "#161447",
          }}
        >
          {props.title}
        </Typography>
        {props.filterModal}
      </Box>
      <Box>
        <Table
          sx={{
            borderCollapse: "separate",
          }}
        >
          <TableHead
            sx={{
              background: "#EEEDF3",
              borderBottomStyle: "none",
              "& th:first-child": {
                borderStyle: "solid",
                borderTopLeftRadius: "20px",
                borderBottomLeftRadius: "20px",
              },
              "& th:last-child": {
                borderStyle: "solid",
                borderTopRightRadius: "20px",
                borderBottomRightRadius: "20px",
              },
            }}
          >
            <TableRow>
              {props.columns.map((column, index) => (
                <TableCell
                  key={index}
                  sx={{
                    paddingY: "1.3rem",
                    fontSize: "20px",
                    fontWeight: "500",
                    lineHeight: "26px",
                  }}
                >
                  {column.headerName}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.isArray(props.rows) && props.rows.length > 0 ? (
              props.rows.map((row) => (
                <>
                  <TableRow
                    key={props.getRowId(row)}
                    sx={{
                      "& td:first-child": {
                        fontSize: "16px",
                        fontWeight: "500",
                        lineHeight: "26px",
                        width: "50%",
                        textWrap: "wrap",
                      },
                      "& td:last-child": {
                        fontSize: "36px",
                        fontWeight: "700",
                        lineHeight: "26px",
                        flex: 1,
                        color: "#161447",
                      },
                    }}
                  >
                    {props.columns.map((column, index) => (
                      <TableCell
                        key={index}
                        sx={{
                          paddingY: "1.3rem",
                        }}
                      >
                        {row[column.field]}
                      </TableCell>
                    ))}
                  </TableRow>
                </>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={props.columns.length}
                  sx={{
                    fontSize: "20px",
                    fontWeight: "500",
                    textAlign: "center",
                  }}
                >
                  No data available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
};
